import styled from 'styled-components';
import { palette } from 'styled-tools';

export const Field = styled.div`
  min-height: 38px;
  margin-bottom: ${(properties) => properties.marginBottom || ''};
  width: 100%;
  position: relative;
  input#customFormatLabel {
    border: ${(properties) =>
      properties.error !== '' ? 'red solid 1px' : 'inherit'};
  }
`;

export const ErrorInputMessage = styled.small`
  margin-top: -10px;
  color: red;
  font-size: 0.8rem;
`;

export const RelativeContainer = styled.div`
  width: 100%;
  position: relative;
  margin-top: ${(properties) => properties.mt ?? 10}px;
  margin-bottom: 10px;
  display: flex;

  span {
    padding: 0 10px;
    display: block;
    margin: auto 0;

    svg {
      color: gray;
      margin-bottom: -3px;
    }
  }
`;

export const FloatButton = styled.button`
  margin-left: auto;
  margin-top: auto;
  margin-bottom: auto;
  font-weight: bolder;
  border: none;
  background: none;
  color: ${(properties) => properties.color ?? palette('colorBody')};
  cursor: pointer;
  font-size: ${(properties) => properties.fontSize ?? 1.2}rem;
  z-index: ${(properties) => properties.zIndex ?? 0};
  display: flex;
  align-items: center;
  ${(properties) =>
    properties.forInput && 'position: absolute; top: 0; height:38px; right:0'};
`;

export const CustomFormWrapper = styled.section`
  border: 1px solid ${palette('borderCard')};
  padding: 5px 10px;
  margin-bottom: 10px;
`;
